import { render } from "./NativePlugins.vue?vue&type=template&id=3b41a287"
import script from "./NativePlugins.vue?vue&type=script&lang=js"
export * from "./NativePlugins.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\wmsapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__